<template>
  <div class="landing-page-container">
    <div id="landingheader" class="landing-page-top-container">
      <nav data-role="Header" class="landing-page-navbar">
        <h1 class="landing-page-logo">
          <span>
            Madeira
            <span v-html="rawk7m0"></span>
          </span>
          <br />
          <span>Roots.tours</span>
        </h1>
        <div class="landing-page-right-side">
          <div class="landing-page-links-container">
            <div class="landing-page-container1">
              <span class="landing-page-text03">Home</span>
            </div>
            <span class="landing-page-text04">About</span>
            <span class="landing-page-text05">Tour Packages</span>
            <router-link to="/landing-page" class="landing-page-navlink">
              Contact
            </router-link>
          </div>
          <a href="#main-section" class="landing-page-link">
            <main-btn button="Book now"></main-btn>
          </a>
        </div>
        <div
          name="burger"
          data-type="BurgerMenu"
          class="landing-page-burger-menu"
        >
          <svg viewBox="0 0 1024 1024" class="landing-page-burger-menu">
            <path
              d="M810.667 725.333h-597.333c-47.061 0-85.333 38.272-85.333 85.333s38.272 85.333 85.333 85.333h597.333c47.061 0 85.333-38.272 85.333-85.333s-38.272-85.333-85.333-85.333z"
            ></path>
            <path
              d="M810.667 426.667h-597.333c-47.061 0-85.333 38.272-85.333 85.333s38.272 85.333 85.333 85.333h597.333c47.061 0 85.333-38.272 85.333-85.333s-38.272-85.333-85.333-85.333z"
            ></path>
            <path
              d="M810.667 128h-597.333c-47.061 0-85.333 38.272-85.333 85.333s38.272 85.333 85.333 85.333h597.333c47.061 0 85.333-38.272 85.333-85.333s-38.272-85.333-85.333-85.333z"
            ></path>
          </svg>
        </div>
        <div
          name="mobile"
          data-type="MobileMenu"
          class="landing-page-mobile-menu"
        >
          <div class="landing-page-nav">
            <div class="landing-page-top">
              <h1>Madeira Roots</h1>
              <div data-type="CloseMobileMenu" class="landing-page-close-menu">
                <svg viewBox="0 0 1024 1024" class="landing-page-icon03">
                  <path
                    d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"
                  ></path>
                </svg>
              </div>
            </div>
            <div class="landing-page-right-side1">
              <div class="landing-page-links-container1">
                <router-link to="/landing-page" class="landing-page-navlink1">
                  Home
                </router-link>
                <router-link to="/landing-page" class="landing-page-navlink2">
                  About
                </router-link>
                <router-link to="/tours" class="landing-page-navlink3">
                  Tour Packages
                </router-link>
                <router-link to="/landing-page" class="landing-page-navlink4">
                  Contact
                </router-link>
              </div>
              <a href="#main-section" class="landing-page-link01">
                <main-btn button="Book now"></main-btn>
              </a>
            </div>
          </div>
          <div class="landing-page-follow-container">
            <span class="landing-page-text06">Follow us on</span>
            <div class="landing-page-icons-container">
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noreferrer noopener"
                class="landing-page-link02"
              >
                <svg
                  viewBox="0 0 877.7142857142857 1024"
                  class="landing-page-icon05"
                >
                  <path
                    d="M585.143 512c0-80.571-65.714-146.286-146.286-146.286s-146.286 65.714-146.286 146.286 65.714 146.286 146.286 146.286 146.286-65.714 146.286-146.286zM664 512c0 124.571-100.571 225.143-225.143 225.143s-225.143-100.571-225.143-225.143 100.571-225.143 225.143-225.143 225.143 100.571 225.143 225.143zM725.714 277.714c0 29.143-23.429 52.571-52.571 52.571s-52.571-23.429-52.571-52.571 23.429-52.571 52.571-52.571 52.571 23.429 52.571 52.571zM438.857 152c-64 0-201.143-5.143-258.857 17.714-20 8-34.857 17.714-50.286 33.143s-25.143 30.286-33.143 50.286c-22.857 57.714-17.714 194.857-17.714 258.857s-5.143 201.143 17.714 258.857c8 20 17.714 34.857 33.143 50.286s30.286 25.143 50.286 33.143c57.714 22.857 194.857 17.714 258.857 17.714s201.143 5.143 258.857-17.714c20-8 34.857-17.714 50.286-33.143s25.143-30.286 33.143-50.286c22.857-57.714 17.714-194.857 17.714-258.857s5.143-201.143-17.714-258.857c-8-20-17.714-34.857-33.143-50.286s-30.286-25.143-50.286-33.143c-57.714-22.857-194.857-17.714-258.857-17.714zM877.714 512c0 60.571 0.571 120.571-2.857 181.143-3.429 70.286-19.429 132.571-70.857 184s-113.714 67.429-184 70.857c-60.571 3.429-120.571 2.857-181.143 2.857s-120.571 0.571-181.143-2.857c-70.286-3.429-132.571-19.429-184-70.857s-67.429-113.714-70.857-184c-3.429-60.571-2.857-120.571-2.857-181.143s-0.571-120.571 2.857-181.143c3.429-70.286 19.429-132.571 70.857-184s113.714-67.429 184-70.857c60.571-3.429 120.571-2.857 181.143-2.857s120.571-0.571 181.143 2.857c70.286 3.429 132.571 19.429 184 70.857s67.429 113.714 70.857 184c3.429 60.571 2.857 120.571 2.857 181.143z"
                  ></path>
                </svg>
              </a>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noreferrer noopener"
                class="landing-page-link03"
              >
                <svg
                  viewBox="0 0 602.2582857142856 1024"
                  class="landing-page-icon07"
                >
                  <path
                    d="M548 6.857v150.857h-89.714c-70.286 0-83.429 33.714-83.429 82.286v108h167.429l-22.286 169.143h-145.143v433.714h-174.857v-433.714h-145.714v-169.143h145.714v-124.571c0-144.571 88.571-223.429 217.714-223.429 61.714 0 114.857 4.571 130.286 6.857z"
                  ></path>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </nav>
      <div class="landing-page-hero">
        <div class="landing-page-content-container">
          <h1 class="landing-page-text07 heading">Book an exclusive</h1>
          <h2 class="landing-page-subheading subheading">
            Discovery Madeira from inside
          </h2>
          <span class="landing-page-text08">
            <span>Each tour is hand-picked and</span>
            <br />
            <span>
              personally guided. An unique experience
              <span v-html="raw98wx"></span>
            </span>
          </span>
          <div class="landing-page-container2">
            <router-link to="/tours" class="landing-page-navlink5">
              <secondary-btn
                button="Explore tours"
                rootClassName="secondary-btn-root-class-name"
                class="landing-page-component02"
              ></secondary-btn>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div id="main-section" class="landing-page-about-u-s">
      <div id="about-us" class="landing-page-banner">
        <h1 class="landing-page-text11 subSectionHeader">Our Mission</h1>
        <span class="landing-page-text12">
          <span>
            <span>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non
              volutpat turpis. Mauris luctus rutrum mi ut rhoncus. Integer in
              dignissim tortor. Lorem ipsum dolor sit amet, consectetur adipiscing
              elit. Sed non volutpat turpis. Mauris luctus rutrum mi ut rhoncus.
              Integer in dignissim tortor. Sed non volutpat turpis. Mauris luctus
              rutrum mi ut rhoncus. Integer in dignissim ortor.
              <span v-html="raweqmf"></span>
            </span>
            <span><span v-html="rawk76b"></span></span>
          </span>
        </span>
        <router-link to="/aboutus" class="landing-page-navlink6">
          <outline-button
            button1="Read more"
            rootClassName="outline-button-root-class-name1"
            class="landing-page-component03"
          ></outline-button>
        </router-link>
      </div>
    </div>
    <div id="main-section" class="landing-page-main">
      <h1 class="subSectionHeader">Most famous tours</h1>
      <span class="landing-page-text17">Recommended</span>
      <div id="best-tours" class="landing-page-cards-container">
        <home-place-card
          city="Above the clouds"
          image="https://images.unsplash.com/photo-1565257625498-e892ef57ea09?ixlib=rb-1.2.1&amp;ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&amp;auto=format&amp;fit=crop&amp;w=687&amp;q=80"
        ></home-place-card>
        <div class="landing-page-container3">
          <home-place-card
            city="Culture"
            image="https://images.unsplash.com/photo-1575540861925-1931f6b4d642?ixlib=rb-1.2.1&amp;ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&amp;auto=format&amp;fit=crop&amp;w=735&amp;q=80"
          ></home-place-card>
        </div>
        <home-place-card
          city="Coast to coast"
          image="https://images.unsplash.com/photo-1630061945673-6b40216122de?ixlib=rb-1.2.1&amp;ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&amp;auto=format&amp;fit=crop&amp;w=1170&amp;q=80"
        ></home-place-card>
      </div>
      <secondary-btn
        button="See all tours"
        rootClassName="secondary-btn-root-class-name2"
      ></secondary-btn>
    </div>
    <div class="landing-page-testimonial">
      <h1 class="landing-page-text18 heading">
        <span>What our clients says</span>
      </h1>
      <span class="landing-page-text20">
        <span>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non
          volutpat turpis. Mauris luctus rutrum mi ut rhoncus
        </span>
      </span>
      <div class="landing-page-container4">
        <testimonial-card3
          name="Roberto Freitas"
          picture_src="https://images.unsplash.com/photo-1583195764036-6dc248ac07d9?ixid=Mnw5MTMyMXwwfDF8c2VhcmNofDE2fHxtYW58ZW58MHx8fHwxNjI2NDUyMDM1&amp;ixlib=rb-1.2.1&amp;h=1200"
          rootClassName="testimonial-card3-root-class-name"
        ></testimonial-card3>
        <testimonial-card3
          name="Mike"
          picture_src="https://images.unsplash.com/photo-1566492031773-4f4e44671857?ixid=Mnw5MTMyMXwwfDF8c2VhcmNofDIzfHxtYW58ZW58MHx8fHwxNjI2NDUyMDM1&amp;ixlib=rb-1.2.1&amp;h=1200"
          rootClassName="testimonial-card3-root-class-name"
        ></testimonial-card3>
        <testimonial-card3
          name="Alberto Joao"
          picture_src="https://images.unsplash.com/photo-1546456073-ea246a7bd25f?ixid=Mnw5MTMyMXwwfDF8c2VhcmNofDh8fGJsYWNrJTIwbWFufGVufDB8fHx8MTYyNjQ1MjAwOA&amp;ixlib=rb-1.2.1&amp;h=1200"
          rootClassName="testimonial-card3-root-class-name"
        ></testimonial-card3>
      </div>
    </div>
    <div class="landing-page-footer">
      <div class="landing-page-menu">
        <h1>
          <span>Madeira</span>
          <br />
          <span>Roots</span>
        </h1>
        <div class="landing-page-links-container2">
          <div class="landing-page-container5">
            <a
              href="https://example.com"
              target="_blank"
              rel="noreferrer noopener"
              class="landing-page-link04"
            >
              Tour packages
            </a>
            <a
              href="https://example.com"
              target="_blank"
              rel="noreferrer noopener"
              class="landing-page-link05"
            >
              Personalized to
            </a>
            <a
              href="https://example.com"
              target="_blank"
              rel="noreferrer noopener"
              class="landing-page-link06"
            >
              Special deals
            </a>
            <a
              href="https://example.com"
              target="_blank"
              rel="noreferrer noopener"
              class="landing-page-link07"
            >
              Summer holiday
              <span v-html="rawlhai"></span>
            </a>
          </div>
          <div class="landing-page-container6">
            <a
              href="https://example.com"
              target="_blank"
              rel="noreferrer noopener"
              class="landing-page-link08"
            >
              About us
            </a>
            <a
              href="https://example.com"
              target="_blank"
              rel="noreferrer noopener"
              class="landing-page-link09"
            >
              FAQ
            </a>
            <a
              href="https://example.com"
              target="_blank"
              rel="noreferrer noopener"
              class="landing-page-link10"
            >
              Terms and conditions
            </a>
            <a
              href="https://example.com"
              target="_blank"
              rel="noreferrer noopener"
              class="landing-page-link11"
            >
              Contact
            </a>
          </div>
        </div>
        <div class="landing-page-follow-container1">
          <span class="landing-page-text25">
            Follow us on
            <span v-html="rawh7ig"></span>
          </span>
          <div class="landing-page-icons-container1">
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noreferrer noopener"
              class="landing-page-link12"
            >
              <svg
                viewBox="0 0 877.7142857142857 1024"
                class="landing-page-icon09"
              >
                <path
                  d="M585.143 512c0-80.571-65.714-146.286-146.286-146.286s-146.286 65.714-146.286 146.286 65.714 146.286 146.286 146.286 146.286-65.714 146.286-146.286zM664 512c0 124.571-100.571 225.143-225.143 225.143s-225.143-100.571-225.143-225.143 100.571-225.143 225.143-225.143 225.143 100.571 225.143 225.143zM725.714 277.714c0 29.143-23.429 52.571-52.571 52.571s-52.571-23.429-52.571-52.571 23.429-52.571 52.571-52.571 52.571 23.429 52.571 52.571zM438.857 152c-64 0-201.143-5.143-258.857 17.714-20 8-34.857 17.714-50.286 33.143s-25.143 30.286-33.143 50.286c-22.857 57.714-17.714 194.857-17.714 258.857s-5.143 201.143 17.714 258.857c8 20 17.714 34.857 33.143 50.286s30.286 25.143 50.286 33.143c57.714 22.857 194.857 17.714 258.857 17.714s201.143 5.143 258.857-17.714c20-8 34.857-17.714 50.286-33.143s25.143-30.286 33.143-50.286c22.857-57.714 17.714-194.857 17.714-258.857s5.143-201.143-17.714-258.857c-8-20-17.714-34.857-33.143-50.286s-30.286-25.143-50.286-33.143c-57.714-22.857-194.857-17.714-258.857-17.714zM877.714 512c0 60.571 0.571 120.571-2.857 181.143-3.429 70.286-19.429 132.571-70.857 184s-113.714 67.429-184 70.857c-60.571 3.429-120.571 2.857-181.143 2.857s-120.571 0.571-181.143-2.857c-70.286-3.429-132.571-19.429-184-70.857s-67.429-113.714-70.857-184c-3.429-60.571-2.857-120.571-2.857-181.143s-0.571-120.571 2.857-181.143c3.429-70.286 19.429-132.571 70.857-184s113.714-67.429 184-70.857c60.571-3.429 120.571-2.857 181.143-2.857s120.571-0.571 181.143 2.857c70.286 3.429 132.571 19.429 184 70.857s67.429 113.714 70.857 184c3.429 60.571 2.857 120.571 2.857 181.143z"
                ></path>
              </svg>
            </a>
            <a
              href="https://facebook.com"
              target="_blank"
              rel="noreferrer noopener"
              class="landing-page-link13"
            >
              <svg
                viewBox="0 0 602.2582857142856 1024"
                class="landing-page-icon11"
              >
                <path
                  d="M548 6.857v150.857h-89.714c-70.286 0-83.429 33.714-83.429 82.286v108h167.429l-22.286 169.143h-145.143v433.714h-174.857v-433.714h-145.714v-169.143h145.714v-124.571c0-144.571 88.571-223.429 217.714-223.429 61.714 0 114.857 4.571 130.286 6.857z"
                ></path>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MainBtn from '../components/main-btn'
import SecondaryBtn from '../components/secondary-btn'
import OutlineButton from '../components/outline-button'
import HomePlaceCard from '../components/home-place-card'
import TestimonialCard3 from '../components/testimonial-card3'

export default {
  name: 'LandingPage',
  components: {
    MainBtn,
    SecondaryBtn,
    OutlineButton,
    HomePlaceCard,
    TestimonialCard3,
  },

  data() {
    return {
      rawk7m0: ' ',
      raw98wx: ' ',
      raweqmf: ' ',
      rawk76b: ' ',
      rawlhai: ' ',
      rawh7ig: ' ',
    }
  },

  metaInfo: {
    title: 'Landing Page - Madeira Roots',
    meta: [
      {
        name: 'description',
        content: 'Deep dive into Madeira Roots',
      },
      {
        property: 'og:title',
        content: 'Landing Page - Madeira Roots',
      },
      {
        property: 'og:description',
        content: 'Deep dive into Madeira Roots',
      },
    ],
  },
}
</script>

<style scoped>
.landing-page-container {
  width: 100%;
  height: auto;
  display: flex;
  min-height: 100vh;
  align-items: center;
  flex-direction: column;
}
.landing-page-top-container {
  width: 100%;
  height: 600px;
  display: flex;
  align-items: center;
  border-radius: var(--dl-radius-radius-radius4);
  flex-direction: column;
  background-size: cover;
  background-image: radial-gradient(circle at center, rgba(119, 109, 73, 0.2) 36.00%,rgba(70, 67, 56, 0.8) 100.00%),url('https://images.unsplash.com/photo-1490902931801-d6f80ca94fe4?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1500&q=80');
  background-position: 0% 40%;
}
.landing-page-navbar {
  width: 100%;
  display: flex;
  padding: var(--dl-space-space-doubleunit);
  max-width: 1000px;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
}
.landing-page-logo {
  color: #ffffff;
}
.landing-page-right-side {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
}
.landing-page-links-container {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
}
.landing-page-container1 {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
}
.landing-page-text03 {
  color: #ffffff;
  cursor: pointer;
  transition: 0.3s;
  margin-right: var(--dl-space-space-doubleunit);
  text-decoration: none;
}
.landing-page-text03:hover {
  border-color: #f5f5f5;
  border-width: 0px;
  border-bottom-width: 1px;
}
.landing-page-text04 {
  color: #ffffff;
  cursor: pointer;
  transition: 0.3s;
  margin-right: var(--dl-space-space-doubleunit);
  text-decoration: none;
}
.landing-page-text04:hover {
  border-color: #f5f5f5;
  border-width: 0px;
  border-bottom-width: 1px;
}
.landing-page-text05 {
  color: #ffffff;
  cursor: pointer;
  transition: 0.3s;
  margin-right: var(--dl-space-space-doubleunit);
  text-decoration: none;
}
.landing-page-text05:hover {
  border-color: #f5f5f5;
  border-width: 0px;
  border-bottom-width: 1px;
}
.landing-page-navlink {
  color: #ffffff;
  cursor: pointer;
  transition: 0.3s;
  margin-right: var(--dl-space-space-doubleunit);
  text-decoration: none;
}
.landing-page-navlink:hover {
  border-color: #f5f5f5;
  border-width: 0px;
  border-bottom-width: 1px;
}
.landing-page-link {
  display: contents;
}
.landing-page-burger-menu {
  display: none;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
}
.landing-page-burger-menu {
  fill: #ffffff;
  width: 24px;
  height: 24px;
}
.landing-page-mobile-menu {
  top: 0px;
  flex: 0 0 auto;
  left: 0px;
  width: 100%;
  height: 100%;
  display: none;
  padding: var(--dl-space-space-doubleunit);
  z-index: 100;
  position: absolute;
  flex-direction: column;
  justify-content: space-between;
  background-color: #fff;
}
.landing-page-nav {
  flex: 0 0 auto;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}
.landing-page-top {
  flex: 0 0 auto;
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: var(--dl-space-space-doubleunit);
  flex-direction: row;
  justify-content: space-between;
}
.landing-page-close-menu {
  flex: 0 0 auto;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}
.landing-page-icon03 {
  width: 24px;
  height: 24px;
}
.landing-page-right-side1 {
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: space-between;
}
.landing-page-links-container1 {
  display: flex;
  align-items: flex-start;
  margin-bottom: 16px;
  flex-direction: column;
  justify-content: space-between;
}
.landing-page-navlink1 {
  margin-bottom: 8px;
  text-decoration: none;
}
.landing-page-navlink2 {
  margin-bottom: 8px;
  text-decoration: none;
}
.landing-page-navlink3 {
  margin-bottom: 8px;
  text-decoration: none;
}
.landing-page-navlink4 {
  text-decoration: none;
}
.landing-page-link01 {
  display: contents;
}
.landing-page-follow-container {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: space-between;
}
.landing-page-text06 {
  padding-bottom: var(--dl-space-space-halfunit);
}
.landing-page-icons-container {
  width: 100px;
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  justify-content: center;
}
.landing-page-link02 {
  display: contents;
}
.landing-page-icon05 {
  width: 24px;
  height: 24px;
}
.landing-page-link03 {
  display: contents;
}
.landing-page-icon07 {
  width: 24px;
  height: 24px;
}
.landing-page-hero {
  flex: 1;
  width: 100%;
  display: flex;
  max-width: 1000px;
  align-items: center;
  padding-top: var(--dl-space-space-tripleunit);
  padding-left: var(--dl-space-space-doubleunit);
  padding-right: var(--dl-space-space-doubleunit);
  flex-direction: row;
  padding-bottom: var(--dl-space-space-tripleunit);
  justify-content: space-between;
}
.landing-page-content-container {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}
.landing-page-text07 {
  color: #ffffff;
}
.landing-page-subheading {
  color: #ffffff;
}
.landing-page-text08 {
  color: #ffffff;
  padding-top: var(--dl-space-space-doubleunit);
  padding-bottom: var(--dl-space-space-doubleunit);
}
.landing-page-container2 {
  flex: 0 0 auto;
  width: auto;
  height: auto;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
}
.landing-page-navlink5 {
  display: contents;
}
.landing-page-component02 {
  text-decoration: none;
}
.landing-page-about-u-s {
  width: 100%;
  height: 465px;
  display: flex;
  transition: 0.3s;
  align-items: center;
  padding-top: var(--dl-space-space-quadruple);
  padding-left: var(--dl-space-space-doubleunit);
  padding-right: var(--dl-space-space-doubleunit);
  flex-direction: column;
  padding-bottom: var(--dl-space-space-quadruple);
  justify-content: flex-start;
  background-color: var(--dl-color-gray-900);
}

.landing-page-banner {
  width: 100%;
  display: flex;
  padding: 48px;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;
}
.landing-page-text11 {
  text-align: center;
}
.landing-page-text12 {
  max-width: 1400px;
  margin-top: 32px;
  text-align: center;
  margin-bottom: 32px;
}
.landing-page-navlink6 {
  display: contents;
}
.landing-page-component03 {
  text-decoration: none;
}
.landing-page-main {
  width: 100%;
  display: flex;
  transition: 0.3s;
  align-items: center;
  padding-top: var(--dl-space-space-quadruple);
  padding-left: var(--dl-space-space-doubleunit);
  padding-right: var(--dl-space-space-doubleunit);
  flex-direction: column;
  padding-bottom: var(--dl-space-space-quadruple);
  justify-content: flex-start;
}

.landing-page-text17 {
  color: var(--dl-color-gray-500);
}
.landing-page-cards-container {
  width: 100%;
  display: flex;
  grid-gap: var(--dl-space-space-doubleunit);
  position: relative;
  flex-wrap: wrap;
  max-width: 1000px;
  margin-top: var(--dl-space-space-doubleunit);
  align-items: flex-start;
  margin-bottom: var(--dl-space-space-doubleunit);
  flex-direction: row;
  justify-content: space-between;
}
.landing-page-container3 {
  flex: 0 0 auto;
  width: 300px;
  height: auto;
  display: flex;
  align-items: space-between;
  flex-direction: column;
}
.landing-page-testimonial {
  width: 100%;
  height: 711px;
  display: flex;
  padding: 48px;
  align-items: center;
  flex-direction: column;
  background-color: var(--dl-color-gray-900);
}
.landing-page-text18 {
  color: var(--dl-color-gray-black);
  list-style-type: disc;
  list-style-image: none;
  list-style-position: outside;
}
.landing-page-text20 {
  color: var(--dl-color-gray-black);
  font-size: 1.15rem;
  max-width: 600px;
  margin-top: 32px;
  text-align: center;
  margin-bottom: 32px;
}
.landing-page-container4 {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: flex-start;
}
.landing-page-footer {
  color: var(--dl-color-gray-white);
  width: 100%;
  display: flex;
  padding: var(--dl-space-space-tripleunit);
  align-items: center;
  flex-direction: row;
  justify-content: center;
  background-color: var(--dl-color-gray-black);
}
.landing-page-menu {
  width: 100%;
  display: flex;
  max-width: 1000px;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
}
.landing-page-links-container2 {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
}
.landing-page-container5 {
  display: flex;
  align-items: flex-start;
  margin-left: 100px;
  flex-direction: column;
}
.landing-page-link04 {
  margin-bottom: var(--dl-space-space-unit);
  text-decoration: none;
}
.landing-page-link05 {
  margin-bottom: var(--dl-space-space-unit);
  text-decoration: none;
}
.landing-page-link06 {
  margin-bottom: var(--dl-space-space-unit);
  text-decoration: none;
}
.landing-page-link07 {
  text-decoration: none;
}
.landing-page-container6 {
  display: flex;
  align-items: flex-start;
  margin-left: 100px;
  flex-direction: column;
}
.landing-page-link08 {
  margin-bottom: var(--dl-space-space-unit);
  text-decoration: none;
}
.landing-page-link09 {
  margin-bottom: var(--dl-space-space-unit);
  text-decoration: none;
}
.landing-page-link10 {
  margin-bottom: var(--dl-space-space-unit);
  text-decoration: none;
}
.landing-page-link11 {
  text-decoration: none;
}
.landing-page-follow-container1 {
  display: flex;
  align-items: center;
  margin-left: 50px;
  flex-direction: column;
  justify-content: space-between;
}
.landing-page-text25 {
  padding-bottom: var(--dl-space-space-halfunit);
}
.landing-page-icons-container1 {
  width: 100px;
  display: flex;
  align-self: flex-end;
  align-items: center;
  flex-direction: row;
  justify-content: center;
}
.landing-page-link12 {
  display: contents;
}
.landing-page-icon09 {
  fill: var(--dl-color-gray-white);
  width: 24px;
  height: 24px;
}
.landing-page-link13 {
  display: contents;
}
.landing-page-icon11 {
  fill: var(--dl-color-gray-white);
  width: 24px;
  height: 24px;
}
@media(max-width: 991px) {
  .landing-page-hero {
    padding-left: var(--dl-space-space-tripleunit);
    padding-right: var(--dl-space-space-tripleunit);
  }
  .landing-page-text12 {
    max-width: 100%;
  }
  .landing-page-cards-container {
    justify-content: center;
  }
  .landing-page-testimonial {
    height: 1261px;
    margin-bottom: 0px;
  }
  .landing-page-text18 {
    text-align: center;
  }
  .landing-page-text20 {
    text-align: center;
  }
  .landing-page-container4 {
    flex-direction: column;
  }
}
@media(max-width: 767px) {
  .landing-page-top-container {
    background: radial-gradient(circle at center, rgba(119, 109, 73, 0.2) 36.00%,rgba(70, 67, 56, 0.8) 100.00%),url('https://images.unsplash.com/photo-1490902931801-d6f80ca94fe4?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1500&q=80');
    background-image: url('https://images.unsplash.com/photo-1490902931801-d6f80ca94fe4?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1500&q=80');
  }
  .landing-page-right-side {
    display: none;
  }
  .landing-page-burger-menu {
    display: flex;
  }
  .landing-page-hero {
    justify-content: center;
  }
  .landing-page-content-container {
    align-items: center;
  }
  .landing-page-text07 {
    font-size: 2.5rem;
  }
  .landing-page-text08 {
    text-align: center;
  }
  .landing-page-about-u-s {
    padding-left: var(--dl-space-space-unit);
    padding-right: var(--dl-space-space-unit);
  }
  .landing-page-banner {
    padding-left: 32px;
    padding-right: 32px;
  }
  .landing-page-text12 {
    padding-left: var(--dl-space-space-unit);
    padding-right: var(--dl-space-space-unit);
  }
  .landing-page-main {
    padding-left: var(--dl-space-space-unit);
    padding-right: var(--dl-space-space-unit);
  }
  .landing-page-testimonial {
    padding-left: 32px;
    padding-right: 32px;
  }
  .landing-page-menu {
    flex-direction: column;
  }
  .landing-page-links-container2 {
    margin-top: var(--dl-space-space-tripleunit);
    margin-bottom: var(--dl-space-space-tripleunit);
    justify-content: space-between;
  }
  .landing-page-container5 {
    margin-left: 0px;
  }
}
@media(max-width: 479px) {
  .landing-page-top-container {
    background-image: radial-gradient(circle at center, rgba(119, 109, 73, 0.2) 36.00%,rgba(70, 67, 56, 0.8) 100.00%),url('https://images.unsplash.com/photo-1490902931801-d6f80ca94fe4?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1500&q=80');
  }
  .landing-page-mobile-menu {
    display: none;
  }
  .landing-page-text07 {
    font-size: 2rem;
    text-align: center;
  }
  .landing-page-subheading {
    font-size: 1.3rem;
    text-align: center;
  }
  .landing-page-banner {
    padding-top: 32px;
    padding-left: var(--dl-space-space-unit);
    padding-right: var(--dl-space-space-unit);
    padding-bottom: 32px;
  }
  .landing-page-testimonial {
    width: 424px;
    height: 1643px;
    padding-top: 32px;
    padding-left: var(--dl-space-space-unit);
    padding-right: var(--dl-space-space-unit);
    padding-bottom: 32px;
  }
  .landing-page-container4 {
    align-self: flex-start;
  }
  .landing-page-links-container2 {
    margin-top: var(--dl-space-space-doubleunit);
    align-items: flex-start;
    justify-content: flex-start;
  }
  .landing-page-link04 {
    margin-bottom: var(--dl-space-space-halfunit);
  }
  .landing-page-link05 {
    margin-bottom: var(--dl-space-space-halfunit);
  }
  .landing-page-link06 {
    margin-bottom: var(--dl-space-space-halfunit);
  }
  .landing-page-link07 {
    margin-bottom: var(--dl-space-space-halfunit);
  }
  .landing-page-container6 {
    height: 100%;
    align-items: flex-start;
    margin-left: 50px;
  }
  .landing-page-link08 {
    margin-bottom: var(--dl-space-space-halfunit);
  }
  .landing-page-link09 {
    margin-bottom: var(--dl-space-space-halfunit);
  }
  .landing-page-link10 {
    margin-bottom: var(--dl-space-space-halfunit);
  }
  .landing-page-link11 {
    margin-bottom: var(--dl-space-space-halfunit);
  }
  .landing-page-follow-container1 {
    margin-left: 0px;
  }
}
</style>
